import type { ReadonlyDeep, SimplifyDeep } from 'type-fest';
import { z } from 'zod';

import { createFrameSchema } from '../robot-config/spatial/frame';
import { RawUIFolderSchema } from './raw-ui-folder';
import { allowVariablePlaceholders } from './raw-variable-placeholder';

const createRawRemoteAuthCredentialsConfigSchema = (allowVariables = false) => {
  return allowVariablePlaceholders(
    z.object({
      type: z.string().optional(),
      payload: z.string().optional(),
    }),
    allowVariables
  ).passthrough();
};

const createRawRemoteAuthConfigSchema = (allowVariables = false) => {
  return allowVariablePlaceholders(
    z.object({
      credentials:
        createRawRemoteAuthCredentialsConfigSchema(allowVariables).optional(),
      entity: z.string().optional(),
    }),
    allowVariables
  ).passthrough();
};

export type RawRemoteAuthCredentialsConfig = SimplifyDeep<
  ReadonlyDeep<
    z.infer<ReturnType<typeof createRawRemoteAuthCredentialsConfigSchema>>
  >
>;

export type RawRemoteAuthConfig = SimplifyDeep<
  ReadonlyDeep<z.infer<ReturnType<typeof createRawRemoteAuthConfigSchema>>>
>;

export type RawRemoteConfig = SimplifyDeep<
  ReadonlyDeep<z.infer<typeof RawRemoteConfigSchema>>
>;

export const createRawRemoteConfigSchema = (allowVariables = false) => {
  return allowVariablePlaceholders(
    z.object({
      name: z.string(),
      address: z.string().optional(),
      prefix: z.string().optional(),
      insecure: z.boolean().optional(),
      auth: createRawRemoteAuthConfigSchema(allowVariables).optional(),
      disabled: z.boolean().optional(),
      notes: z.string().optional(),
      ui_folder: RawUIFolderSchema.optional(),
      frame: createFrameSchema(allowVariables).optional(),
    }),
    allowVariables
  ).passthrough();
};

export const RawRemoteConfigSchema = createRawRemoteConfigSchema();
